import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

type FrMrpaxePricingVersionFormat = PricingVersionFormat<'fr-mrp-axeria'>

export const frMrpaxePricingVersions = [
  ['pricing-fr-mrp-axeria-1.0.0-2026-10-03', { label: 'Version 1' }],
] as const satisfies PricingVersionTuple<FrMrpaxePricingVersionFormat>[]

export type FrMrpaxePricingVersion = (typeof frMrpaxePricingVersions)[number][0]
